import { normalizeError } from '@/helpers';
import { CustomerApi } from '@/services';
import { createAsyncThunk } from '@reduxjs/toolkit';
export const fetchCustomerMatchedGrantsAsync = createAsyncThunk('customers/customer/matchedGrants', async ({ customerId, options }, { rejectWithValue }) => {
    try {
        const res = await CustomerApi.fetchCustomerMatchedGrants(customerId, options);
        return res.data;
    }
    catch (error) {
        const normalized = normalizeError(error, 'fetching customer matched grants');
        return rejectWithValue(normalized);
    }
});
export const fetchCustomerMatchedGrantsAsyncBuilder = (builder) => {
    builder.addCase(fetchCustomerMatchedGrantsAsync.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = '';
    });
    builder.addCase(fetchCustomerMatchedGrantsAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.data = action.payload;
    });
    builder.addCase(fetchCustomerMatchedGrantsAsync.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload;
    });
};
